<template>
  <v-card class="elevation-1 mb-6 rounded-lg mt-0">
    <v-card-title class="pa-7">
      Přehled uživatelů
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="messageHeadersByRole"
        :items="user.items"
        :options.sync="user.options"
        :server-items-length="user.serverItemsLength"
        :loading="user.loading"
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:item.customer.id="{ item }">
          <span v-if="item.user && item.user.customer && item.user.customer.id">
            <router-link
              :to="{
                name: 'customers.detail',
                params: {
                  customerId: item.user.customer.id,
                },
              }"
            >
              {{ item.user.customer.id }}
            </router-link>
          </span>
        </template>
        <template v-slot:item.status="{ item }">
          <MessageStatus :status="item.status" :max="false" />
        </template>
        <template v-slot:item.createdAt="{ item }">
          <DateTime :datetime="item.createdAt" :single-line="false" />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '@/components/DateTime'
import MessageStatus from './MessageStatus'

export default {
  name: 'MessageUsers',
  components: {
    MessageStatus,
    DateTime,
  },
  mixins: [setFilters],
  props: {
    id: {
      id: Number,
      required: true,
    },
  },
  data() {
    return {
      user: {
        headers: [
          {
            text: 'Datum',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Id',
            value: 'customer.id',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Jméno',
            value: 'user.customer.fullName',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Stav',
            value: 'status',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['createdAt'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      userFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    messageHeadersByRole() {
      return this.user.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    'user.options': {
      handler() {
        this.loadMessageUsers()
      },
    },
    '$route.query': {
      handler() {
        this.loadMessageUsers()
      },
    },
  },
  methods: {
    ...mapActions({
      searchMessageUsers: 'message/searchMessageUsers',
    }),
    loadMessageUsers() {
      this.user.loading = true
      let filterParams = this.$route.query
      filterParams['messageId'] = this.id
      filterParams['types'] = ['CLOSABLE']
      filterParams['origin'] = false
      const searchParams = {
        filterParams: filterParams,
        options: this.user.options,
      }
      this.searchMessageUsers(searchParams)
        .then((response) => {
          this.userFooter.totalElements = response.data.totalElements
          this.user.items = response.data.items
          this.user.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.user.loading = false
        })
    },
    setFiltersAction(filters) {
      this.user.options.page = 1
      this.setFilters(filters)
    },
  },
}
</script>
